import { useState, useEffect } from 'react';
import { FiBell, FiSearch, FiMenu, FiMoon, FiSun, FiUser, FiSettings } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const Header = ({ onMenuClick, title }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [notifications] = useState([
    {
      id: 1,
      type: 'order',
      message: 'New order received #ORD-2024-02',
      time: '5 minutes ago',
      priority: 'high'
    },
    {
      id: 2,
      type: 'alert',
      message: 'Low stock alert: Silk Saree - Blue',
      time: '10 minutes ago',
      priority: 'medium'
    },
    {
      id: 3,
      type: 'payment',
      message: 'Payment received for order #ORD-2024-01',
      time: '1 hour ago',
      priority: 'low'
    }
  ]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200">
      <div className="px-4 sm:px-6 lg:px-8 lg:ml-64">
        <div className="flex items-center justify-between h-20">
          {/* Left Section */}
          <div className="flex items-center gap-4">
            <button
              onClick={onMenuClick}
              className="text-gray-500 hover:text-gray-700 lg:hidden focus:outline-none"
            >
              <FiMenu className="h-7 w-7" />
            </button>
            <div className="flex items-center space-x-3">
              <h1 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                {title}
              </h1>
              <div className="h-8 w-[1px] bg-gray-300" />
              <div className="text-base text-gray-500">
                <div>{formatTime(currentTime)}</div>
                <div className="text-sm">{formatDate(currentTime)}</div>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-4">
            {/* Add your right section content here (notifications, user menu, etc.) */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;







